import { TranslationKeys } from '.';


export const lang: Record<TranslationKeys, string> = {
    show: 'Visa',
    hide: 'Dölj',
    'content-for': 'innehåll för',
    'submenu-for': 'undermeny för',
    'follow-us-on': 'Följ oss på',
    'written-by': 'Skrivet av',
    'all': 'Alla',
    'load-more': 'Ladda mer',
    'filter-on': 'Filtrera på',
    'minute-read': 'minut läsning',
    'accept-terms': 'Du måste acceptera villkoren',
    'is-required': 'är obligatoriskt',
    'form-sent': 'Formuläret skickades!',
    'form-error': 'Något gick fel, försök igen',
    'email-invalid': 'E-post är ogiltig',
    'first-name-invalid': 'Förnamnet är ogiltigt',
    'last-name-invalid': 'Efternamnet är ogiltigt',
    'zip-code-invalid': 'Postnummer är ogiltigt',
    'phone-invalid': 'Telefonnummer är ogiltigt',
    'see-our-projects': 'Se våra projekt',
    'news': 'Nyheter',
    'press': 'Press',
    'close-menu': 'Stäng meny',
    'find-something-good': 'Hitta något bra!',
    'search-hint': 'Sök här...',
    'found': 'Hittade',
    'hits': 'träffar',
};